import React from 'react';
import { Container } from './ui/Container';
import { Check, X } from 'lucide-react';
export function DifferentiationSection() {
  return <section className="py-16 bg-white" data-id="element-39">
      <Container data-id="element-40">
        <div className="text-center mb-12" data-id="element-41">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-42">
            Why SnoreStop™ Beats Everything Else
          </h2>
          <div className="max-w-2xl mx-auto space-y-3 text-left" data-id="element-43">
            {['Works from the first night', 'No machines, wires or noise', 'Comfortable and moldable', 'One-time purchase', 'Relationship-saving results'].map((reason, i) => <div key={i} className="flex items-center text-lg" data-id="element-44">
                <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-45" />
                <span className="font-medium text-gray-800" data-id="element-46">{reason}</span>
              </div>)}
          </div>
        </div>

        <div className="overflow-x-auto" data-id="element-47">
          <table className="w-full max-w-5xl mx-auto border-collapse" data-id="element-48">
            <thead data-id="element-49">
              <tr className="bg-gray-50" data-id="element-50">
                <th className="p-4 text-left text-gray-500 font-medium" data-id="element-51">
                  Feature
                </th>
                <th className="p-4 text-center bg-blue-50 border-t-4 border-blue-600 text-blue-900 font-bold text-lg" data-id="element-52">
                  SnoreStop™
                </th>
                <th className="p-4 text-center text-gray-500 font-medium" data-id="element-53">
                  Nose Strips
                </th>
                <th className="p-4 text-center text-gray-500 font-medium" data-id="element-54">
                  Sprays
                </th>
                <th className="p-4 text-center text-gray-500 font-medium" data-id="element-55">
                  CPAP
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-56">
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-57">
                <td className="p-4 font-semibold text-gray-900" data-id="element-58">
                  Reduces snoring
                </td>
                <td className="p-4 text-center bg-blue-50/50" data-id="element-59">
                  <Check className="w-5 h-5 text-green-500 mx-auto" data-id="element-60" />
                </td>
                <td className="p-4 text-center" data-id="element-61">
                  <X className="w-5 h-5 text-red-400 mx-auto" data-id="element-62" />
                </td>
                <td className="p-4 text-center" data-id="element-63">
                  <X className="w-5 h-5 text-red-400 mx-auto" data-id="element-64" />
                </td>
                <td className="p-4 text-center" data-id="element-65">
                  <Check className="w-5 h-5 text-gray-400 mx-auto" data-id="element-66" />
                </td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-67">
                <td className="p-4 font-semibold text-gray-900" data-id="element-68">Comfortable</td>
                <td className="p-4 text-center bg-blue-50/50" data-id="element-69">
                  <Check className="w-5 h-5 text-green-500 mx-auto" data-id="element-70" />
                </td>
                <td className="p-4 text-center" data-id="element-71">
                  <X className="w-5 h-5 text-red-400 mx-auto" data-id="element-72" />
                </td>
                <td className="p-4 text-center" data-id="element-73">
                  <X className="w-5 h-5 text-red-400 mx-auto" data-id="element-74" />
                </td>
                <td className="p-4 text-center" data-id="element-75">
                  <X className="w-5 h-5 text-red-400 mx-auto" data-id="element-76" />
                </td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-77">
                <td className="p-4 font-semibold text-gray-900" data-id="element-78">Silent</td>
                <td className="p-4 text-center bg-blue-50/50" data-id="element-79">
                  <Check className="w-5 h-5 text-green-500 mx-auto" data-id="element-80" />
                </td>
                <td className="p-4 text-center" data-id="element-81">
                  <Check className="w-5 h-5 text-gray-400 mx-auto" data-id="element-82" />
                </td>
                <td className="p-4 text-center" data-id="element-83">
                  <Check className="w-5 h-5 text-gray-400 mx-auto" data-id="element-84" />
                </td>
                <td className="p-4 text-center" data-id="element-85">
                  <X className="w-5 h-5 text-red-400 mx-auto" data-id="element-86" />
                </td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-87">
                <td className="p-4 font-semibold text-gray-900" data-id="element-88">
                  Travel-friendly
                </td>
                <td className="p-4 text-center bg-blue-50/50" data-id="element-89">
                  <Check className="w-5 h-5 text-green-500 mx-auto" data-id="element-90" />
                </td>
                <td className="p-4 text-center" data-id="element-91">
                  <X className="w-5 h-5 text-red-400 mx-auto" data-id="element-92" />
                </td>
                <td className="p-4 text-center" data-id="element-93">
                  <X className="w-5 h-5 text-red-400 mx-auto" data-id="element-94" />
                </td>
                <td className="p-4 text-center" data-id="element-95">
                  <X className="w-5 h-5 text-red-400 mx-auto" data-id="element-96" />
                </td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-97">
                <td className="p-4 font-semibold text-gray-900" data-id="element-98">
                  One-time cost
                </td>
                <td className="p-4 text-center bg-blue-50/50" data-id="element-99">
                  <Check className="w-5 h-5 text-green-500 mx-auto" data-id="element-100" />
                </td>
                <td className="p-4 text-center" data-id="element-101">
                  <X className="w-5 h-5 text-red-400 mx-auto" data-id="element-102" />
                </td>
                <td className="p-4 text-center" data-id="element-103">
                  <X className="w-5 h-5 text-red-400 mx-auto" data-id="element-104" />
                </td>
                <td className="p-4 text-center" data-id="element-105">
                  <X className="w-5 h-5 text-red-400 mx-auto" data-id="element-106" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="mt-16 max-w-4xl mx-auto" data-id="element-107">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center" data-id="element-108">
            Common Concerns Answered
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-109">
            {[{
            objection: 'It looks uncomfortable',
            answer: "Actually, most people forget they're wearing it after 2–3 nights. The soft BPA-free material molds gently to your mouth."
          }, {
            objection: "It won't fit my mouth",
            answer: 'SnoreStop™ is heat-moldable and adjustable. One size fits 99% of mouths — no dentist visit needed.'
          }, {
            objection: "I'm afraid I'll choke",
            answer: "It doesn't block your breathing. It opens your airway so you breathe more freely, not less."
          }, {
            objection: 'I already tried other things',
            answer: "That's exactly why SnoreStop™ exists. Sprays, pillows, nose strips and apps don't fix airway collapse."
          }, {
            objection: 'This feels like another scam',
            answer: "Try it for 30 nights. If it doesn't reduce your snoring, you get a full refund. No forms. No arguments. No BS."
          }].map((item, i) => <div key={i} className="bg-gray-50 rounded-lg p-5 border border-gray-100" data-id="element-110">
                <p className="font-bold text-gray-900 mb-2 flex items-start" data-id="element-111">
                  <X className="w-5 h-5 text-red-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-112" />
                  "{item.objection}"
                </p>
                <p className="text-gray-700 ml-7" data-id="element-113">{item.answer}</p>
              </div>)}
          </div>
        </div>
      </Container>
    </section>;
}